export default {
    namespaced: true,

    state: () => {
        return {
            data: {}
        }
    },

    mutations: {
        update(state, account) {
            state.data = account
        },
    },
}
